// Hatnote: an opening paragraph set entirely in italics ("(Part 1 of this
// story.)") is a navigational aside, not the article's first prose, so the
// versal belongs on the paragraph after it. CSS can't decide this — text
// nodes are invisible to selectors, so `:has(> em:first-child)` can't tell
// a wholly italic line from one with an italic word in it — so mark the
// paragraph with .is-hatnote and let content.css move the versal.
export default function hatnote() {
    const first = document.querySelector(".gh-content > p:first-of-type");
    if (!first || !first.textContent.trim()) return;

    const walker = document.createTreeWalker(first, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        if (!node.data.trim()) continue;
        const italic = node.parentElement.closest("em, i");
        if (!italic || !first.contains(italic)) return;
    }
    first.classList.add("is-hatnote");
}
